module.exports = __webpack_public_path__ + "img/requirements.b22d32f4.svg";